import {Component, Inject, Injectable, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {SettingsDataService} from '../settings-data.service';
import {HttpClient} from '@angular/common/http';
import {StopPrediction} from '../model/stopprediction.model';
import {map} from 'rxjs/operators';
import {Stop} from '../model/stop.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {StopPredictionData} from '../model/stopprediction.data.model';
import {TrackVehicle} from '../model/track-vehicle.model';
import {combineLatest} from 'rxjs';
import {DlDateTimePickerChange} from 'angular-bootstrap-datetimepicker';
import {HereMapConverter} from '../model/here-map-converter';

function removeAllFromList(strings: string[]) {
  const index = strings.indexOf('ALL');
  if (index !== -1) {
    strings.splice(index, 1);
  }
  return strings;
}

@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit, OnDestroy {
  stopPrediction: StopPrediction;
  availableRoutes: string[];
  displayedColumns: string[] = ['route', 'vehicle', 'destination', 'info'];
  loading: boolean;
  pinned: boolean;
  selectedRoute: string[];
  epoch: number = null;
  epochDate: Date;

  stopIdSubscription: any;
  refreshAllSubscription: any;

  constructor(private router: Router, private route: ActivatedRoute,
              private settingsDataService: SettingsDataService,
              private http: HttpClient, private snackBar: MatSnackBar,
              public dialog: MatDialog, public location: Location) {

    const obsComb = combineLatest(this.route.params, this.route.queryParams,
      (params, qparams) => ({params, qparams}));

    obsComb.subscribe(ap => {
      const params = ap.params;
      const qparams = ap.qparams;

      let resolvedRoute: string = null;
      let resolvedProvider = 'NJT_BUS';
      let resolvedStop: string = null;
      let state = '0';

      if (params !== null && params !== undefined) {
        if (params['pid'] !== null && params['pid'] !== undefined) {
          resolvedProvider = params['pid'];
        }
        if (params['id'] !== null && params['id'] !== undefined) {
          resolvedRoute = params['id'];
        }
        if (params['stop'] !== null && params['stop'] !== undefined) {
          resolvedStop = params['stop'];
        }
      }

      if (qparams !== null && qparams !== undefined) {
        if (qparams['state'] !== null && qparams['state'] !== undefined) {
          state = qparams['state'];
        }
      }

      if (resolvedProvider !== null && resolvedProvider.toUpperCase().localeCompare('PATH') === 0
        && resolvedRoute !== null && resolvedRoute.toUpperCase().localeCompare('SHOWALL') === 0) {
        this.settingsDataService.addRoute('JSQ-33rd St', resolvedProvider);
        this.settingsDataService.addRoute('NWK-WTC', resolvedProvider);
        this.settingsDataService.addRoute('HOB-33', resolvedProvider);
        this.settingsDataService.addRoute('HOB-WTC', resolvedProvider);
        this.settingsDataService.addRoute('JSQ-33 (via HOB)', resolvedProvider);
        this.snackBar.open('Adding PATH', 'Dismiss', {duration: 10000});

      } else if (resolvedRoute !== null && resolvedRoute.toUpperCase().localeCompare('ALL') !== 0) {
        if (this.settingsDataService.addRoute(resolvedRoute, resolvedProvider)) {
          this.snackBar.open('Adding ' + resolvedProvider + ' - Route ' + resolvedRoute, 'Dismiss', {duration: 10000});
        }
      }
      if (resolvedStop !== null) {
        this.settingsDataService.updateStopID(resolvedStop, resolvedProvider, resolvedRoute);

        if (state.localeCompare('0') === 0) {
          this.http.get(`https://ShowMeMyCommute.com:5928/getStopInfo?providerId=${resolvedProvider}&stopId=${resolvedStop}`)
            .pipe(map(res => new Stop().deserialize(res)))
            .subscribe(vc => {
              this.settingsDataService.updatePinnedStop(vc, true);
            }, err => {
              console.log(err);
              this.loading = false;
            });
        }
      }
      this.location.replaceState(this.location.path().split('?')[0], '');
      // this.router.navigate(['/']);
    });
    this.stopPrediction = new StopPrediction();
    this.availableRoutes = this.settingsDataService.stopIdRoute.split(',');
    this.selectedRoute = removeAllFromList(this.availableRoutes);

    this.stopIdSubscription = this.settingsDataService.stopIdRefresh.subscribe(() => this.update());
    this.refreshAllSubscription = this.settingsDataService.refreshAll.subscribe(() => this.refresh());
    this.loading = false;
  }

  ngOnInit() {
    this.refresh();

    if (this.settingsDataService.routes === null ||
      this.settingsDataService.routes === undefined ||
      (this.settingsDataService.routes.length === 0 && this.settingsDataService.stops.length === 0)) {
      const dialogRef = this.dialog.open(ListAddRouteComponent, {width: '400px', height: '300px', hasBackdrop: false});
      dialogRef.afterClosed().subscribe(data => {
          this.settingsDataService.routeAdded.emit(true);
          this.settingsDataService.refreshAll.emit();
        }
      );
    }

  }

  ngOnDestroy() {
    this.stopIdSubscription.unsubscribe();
    this.refreshAllSubscription.unsubscribe();
  }

  update() {
    this.epoch = null;
    this.refresh();
  }

  refresh() {
    console.log('refreshing');
    if (this.settingsDataService.stopId !== null && this.settingsDataService.stopId !== undefined) {
      let url: string;
      const currentRefreshStopId = this.settingsDataService.stopId;
      if ('ALL' === this.settingsDataService.stopIdRoute) {
        url = `https://ShowMeMyCommute.com:5928/getStopPrediction` +
          `?version=2&providerId=${this.settingsDataService.stopIdProvider}&clientId=${this.settingsDataService.identifier}&stopId=${this.settingsDataService.stopId}`;
      } else {
        url = `https://ShowMeMyCommute.com:5928/getStopPrediction` +
          `?version=2&providerId=${this.settingsDataService.stopIdProvider}&clientId=${this.settingsDataService.identifier}E&stopId=${this.settingsDataService.stopId}&routeId=${this.settingsDataService.stopIdRoute}`;
      }

      if (this.epoch !== null && this.epoch !== undefined) {
        url += '&epoch=' + this.epoch;
      }

      if (this.settingsDataService.isPinned(this.settingsDataService.stopId, this.settingsDataService.stopIdProvider)) {
        this.pinned = true;
      } else {
        this.pinned = false;
      }

      this.loading = true;
      this.http.get(url)
        .pipe(map(res => new StopPrediction().deserialize(res)))
        .subscribe(vc => {
          if (this.settingsDataService.stopId.localeCompare(vc.stopId) === 0) {

            this.stopPrediction = vc;
            vc.routes.forEach(v => {
              if (this.availableRoutes.indexOf(v) === -1) {
                this.availableRoutes.push(v);
              }
            });
            const removeRoute = [];
            this.availableRoutes.forEach(v => {
              const index = vc.routes.indexOf(v);
              if (index === -1) {
                removeRoute.push(v);
              }
            });
            removeRoute.forEach(v => {
              const index = this.availableRoutes.indexOf(v);
              this.availableRoutes.splice(index, 1);
            });

            this.availableRoutes.sort((route1: string, route2: string): number => {
              let result: number;
              result = parseInt(route1, 10) - parseInt(route2, 10);

              if (result === 0 || Number.isNaN(result)) {
                return route1.localeCompare(route2);
              } else {
                return result;
              }
            });

            if (this.settingsDataService.stopIdRoute !== null && this.settingsDataService.stopIdRoute !== undefined) {

              this.selectedRoute = removeAllFromList(this.settingsDataService.stopIdRoute.split(','));
            }

          }


          this.loading = false;
        }, err => {
          console.log(err);
          this.loading = false;
        });
    }
  }

  updateRouteSelection(): boolean {
    let routes = this.selectedRoute.join();
    if (this.selectedRoute.indexOf('ALL') !== -1) {
      routes = 'ALL';
      this.selectedRoute = 'ALL'.split(',');
    }

    this.settingsDataService.updateStopIDRoute(routes, false);
    return false;
  }

  pin(checkbox: HTMLInputElement) {
    const stop = HereMapConverter.convert(this.stopPrediction);
    if (this.settingsDataService.stopIdRoute !== null && this.settingsDataService.stopIdRoute !== undefined) {
      stop.route = this.settingsDataService.stopIdRoute;
    }
    this.settingsDataService.updatePinnedStop(stop, checkbox.checked);
  }

  onClick(data: StopPredictionData, provider: string) {
    this.settingsDataService.activityDetected.emit('onclick');
    if (data.vehicleId !== undefined) {
      const vehicle = new TrackVehicle();
      vehicle.provider = provider;
      vehicle.vehicleId = data.vehicleId;
      vehicle.routeId = data.routeId;

      console.log('onclick');
      this.settingsDataService.trackVehicle.emit(vehicle);
      this.settingsDataService.refreshAll.emit();
    }
  }

  setTime() {
    const dialogRef = this.dialog.open(ListSetTimeComponent, {});
    dialogRef.afterClosed().subscribe(data => {
        console.log(data);
        if (data !== null && data !== undefined) {
          this.epoch = Math.floor(data.getTime() / 1000);
          this.epochDate = data;
        } else {
          this.epoch = null;
          this.epochDate = null;
        }
        this.refresh();
      }
    );
  }

  removeDate() {
    this.epoch = null;
    this.epochDate = null;
    this.refresh();
  }

  goToHistory(data: StopPredictionData) {
    this.router.navigate(['/history/' + data.vehicleId]);
  }

  setRouteStyle(routeId: string) {
    if (routeId !== null && routeId !== undefined) {
      const color = this.settingsDataService.getColor(routeId);
      return {'background-color': color};
    } else {
      return {};
    }
  }

  isExperimental() {
    return this.settingsDataService.experimental;
  }

  goBackTime() {
    if (this.epochDate === null || this.epochDate === undefined) {
      this.epochDate = new Date();
      this.epoch = Math.floor(this.epochDate.getTime() / 1000);
    }

    this.epochDate = new Date(this.epochDate.getTime() - 1000 * 60 * 15);
    this.epoch = Math.floor(this.epochDate.getTime() / 1000);

    this.refresh();
  }

  adminCommand(data: StopPredictionData) {
    if (this.isExperimental()) {
      const dialogRef = this.dialog.open(ListAdminComponent, {
        width: '400px',
        height: '500px',
        hasBackdrop: false,
        data: {blockId: data.tripId}
      });
      dialogRef.afterClosed().subscribe(d => {
          this.settingsDataService.refreshAll.emit();
        }
      );
    }
  }

  showMessage(stopPrediction: StopPrediction) {
    this.dialog.open(MessageComponent, {data: {message: stopPrediction.message, url: stopPrediction.url}});
  }
}

@Component({
  selector: 'app-list-settime.component',
  template: `
    <div mat-dialog-content style="width:100%;">
      <label>Lookup schedule for a specific date/time:</label>
      <dl-date-time-picker
        maxView="month"
        minView="hour"
        startView="day"
        minuteStep="5"
        [(ngModel)]="selectedDate"
        (change)="changed($event)">
      </dl-date-time-picker>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Cancel</button>
      <button mat-button color="primary" [mat-dialog-close]="selectedDate" cdkFocusInitial>Ok</button>
    </div>
  `
})
export class ListSetTimeComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ListSetTimeComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedDate: Date) {
  }

  ngOnInit() {

  }

  onNoClick() {
    this.dialogRef.close();
  }

  changed(event: DlDateTimePickerChange<Date>) {
    if (event !== null && event !== undefined && event.value !== null && event.value !== undefined) {
      this.dialogRef.close(event.value);
    }

  }
}


@Component({
  selector: 'app-list-addroute.component',
  template: `
    <div mat-dialog-content style="width:100%;height:200px">
      <label>Add route:</label>
      <br/>
      <mat-form-field floatLabel="never" style="max-width:100px;max-height:25px">
        <select (change)="onChangeProvider($event)" [(ngModel)]="provider" matNativeControl placeholder="Select Provider"
                required>
          <option *ngFor="let provider of this.settingsDataService.getValidProviders()"
                  value={{provider}}>{{provider}}</option>
        </select>
      </mat-form-field>
      <mat-form-field floatLabel="never" style="margin:15px;max-width:100px;max-height:25px" cdkFocusInitial>
        <select [(ngModel)]="selected" matNativeControl placeholder="Route" required>
          <option *ngFor="let route of this.settingsDataService.getValidRoutes(provider)"
                  value={{route}}>{{route}}</option>
        </select>
      </mat-form-field>
      <br/>
      <br/>
      <button (click)="addRoute()">Add</button>
    </div>
    <div mat-dialog-actions>
      <button mat-button color="primary" (click)="close()">Done</button>
    </div>
  `
})
export class ListAddRouteComponent implements OnInit {

  selected: string;
  provider = 'NJT_BUS';

  constructor(
    public dialogRef: MatDialogRef<ListAddRouteComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedDate: Date,
    public settingsDataService: SettingsDataService, public snackBar: MatSnackBar) {
  }

  ngOnInit() {

  }

  addRoute() {
    if (this.provider === null || this.provider === undefined) {
      this.provider = 'NJT_BUS';
    }

    this.settingsDataService.addRoute(this.selected, this.provider);

    this.snackBar.open('Adding ' + this.provider + ' - Route ' + this.selected, 'Dismiss', {duration: 10000});
    return false;
  }

  onChangeProvider(event) {
    const routes = this.settingsDataService.getValidRoutes(this.provider);
    if (routes !== null && routes !== undefined && routes.length > 0) {
      this.selected = routes[0];
    }
  }

  close() {
    const routes = this.settingsDataService.getCount();
    if (routes === 0) {
      if (this.selected === undefined || this.selected === null) {
        this.snackBar.open('Please add a route', 'OK', {duration: 10000});
      } else {
        this.addRoute();
        this.dialogRef.close();
      }
    } else {

      this.dialogRef.close();
    }
  }
}


@Component({
  selector: 'app-list-admin.component',
  template: `
    <div mat-dialog-content style="width:100%;">

      <mat-form-field>
        <input [(ngModel)]="blockId" matInput placeholder="Block #">
      </mat-form-field>
      <mat-form-field>
        <input [(ngModel)]="vehicleId" matInput placeholder="Vehicle #">
      </mat-form-field>
      <button mat-button (click)="setVehicle()">Set Vehicle</button>

      <br/>
      <br/>
      <mat-form-field>
        <input [(ngModel)]="routeId" matInput placeholder="Route #">
      </mat-form-field>
      <mat-form-field>
        <input [(ngModel)]="message" matInput placeholder="Message">
      </mat-form-field>
      <button mat-button (click)="setMessage()">Set Message</button>


    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Done</button>
    </div>
  `
})
export class ListAdminComponent implements OnInit {
  blockId: string;
  vehicleId: string;
  routeId: string;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<ListAdminComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.blockId = data.blockId;
    this.vehicleId = '';
    this.routeId = '';
    this.message = '';
  }

  ngOnInit() {

  }

  onNoClick() {
    this.dialogRef.close();
  }

  setVehicle() {
    this.http.get(`https://ShowMeMyCommute.com:5928` +
      `/njt/block?v=${this.vehicleId}&b=${this.blockId}`).subscribe(any => {
    });
  }

  setMessage() {
    this.http.get(`https://ShowMeMyCommute.com:5928` +
      `/njt/message?r=${this.routeId}&m=${this.message}`).subscribe(any => {
    });
  }
}


@Component({
  selector: 'app-message.component',
  template: `
    <div mat-dialog-content style="width:100%;height:100%; white-space: pre-wrap;">
      {{message}}
    </div>
    <div mat-dialog-actions>
      <button mat-button color="primary" [mat-dialog-close]="true">Close</button>
      <a mat-button href="{{url}}"
         *ngIf="url !== undefined && url !== null" color="accent"
         mat-raised-button target="blank">See more alerts</a>
    </div>
  `
})
export class MessageComponent implements OnInit {
  message: string;
  url: string;

  constructor(
    public dialogRef: MatDialogRef<MessageComponent>,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    this.url = data.url;
  }

  ngOnInit() {

  }

  onNoClick() {
    this.dialogRef.close();
  }

}
